import { useState } from "react";
import { Form } from "react-bootstrap";
import FilterMenuNew from "../../components/FilterMenuNew";
import YuJaButton from "../../components/standardization/YuJaButton";
import { YuJaTextBox } from "../../components/standardization/YuJaTextBox";
import { ReactComponent as PlusIcon } from "../../images/plus.svg";
import { ReactComponent as SearchIcon } from "../../images/search_bar_icon.svg";
import { notifyError } from "../../utils/helpers";
import styles from "./ManageUserPage.module.css";
import { useTranslation } from "react-i18next";
import { translateDisplayValue } from "../../utils/displayLabel";

export default function UserSearchForm({ handleSubmit, handleCreate, handleDelete, showDeleteButton, roles, linkageTypes, disabled=false }) {
    const { t } = useTranslation();
    const [keyword, setKeyword] = useState("");
    const [roleFilter, setRoleFilter] = useState([]);
    const [linkageTypeFilter, setLinkageTypeFilter] = useState([]);
    const [dateCreatedFilter, setDateCreatedFilter] = useState("");
    const [lastAccessedFilter, setLastAccessedFilter] = useState("");

    const clickSearch = ({key=keyword, dc=dateCreatedFilter, la=lastAccessedFilter, r=roleFilter, lt=linkageTypeFilter}) => {
        if (disabled) {
            notifyError(t("user.loadingSearchError"));
            return;
        }
        handleSubmit({
            keyword: key,
            dateCreated: dc ? dc.split("-").reverse().join("-") : "",
            lastAccessed: la ? la.split("-").reverse().join("-") : "",
            role: r,
            linkageType: lt
        });
    };

    const enterKeyup = (e) => {
        if (e.key === 'Enter') {
            clickSearch({});
        }
    }

    const onApply = (filterOptions) => {
        setRoleFilter(filterOptions.optionFilter1);
        setLinkageTypeFilter(filterOptions.optionFilter2);
        setDateCreatedFilter(filterOptions.dateFilter1);
        setLastAccessedFilter(filterOptions.dateFilter2);
        clickSearch({dc: filterOptions.dateFilter1, la: filterOptions.dateFilter2, r: filterOptions.optionFilter1, lt: filterOptions.optionFilter2});
    };

    return (
        <div className={styles.searchBox}>
            <Form className={styles.searchBoxForm} onSubmit={e => e.preventDefault()}>
                <FilterMenuNew
                    onApply={onApply}
                    disabled={disabled}
                    onDisabledOpen={() => notifyError(t("user.loadingFilterError"))}
                    className={styles.filterMenu}
                    filterOptions={{
                        separateDates: true,
                        optionFilter1Name: t("auth.roleLabel"),
                        optionFilter1: roleFilter,
                        optionsFilter1: roles,
                        optionFilter2Name: t("integration.linkageType"),
                        optionFilter2: linkageTypeFilter,
                        optionsFilter2: linkageTypes,
                        dateFilter1Name: t("table.dateCreatedHeader"),
                        dateFilter1: dateCreatedFilter,
                        dateFilter2Name: t("table.lastAccessedHeader"),
                        dateFilter2: lastAccessedFilter
                    }}
                />
                <YuJaTextBox
                    containerStyle={{width: "40vw", fontSize: 12, lineHeight: 1.6, marginLeft: 10}}
                    placeholder={t("user.searchUser")}
                    onChange={e => setKeyword(e.target.value)}
                    onKeyUp={enterKeyup}
                    value={keyword}
                    before={<SearchIcon style={{width: 16, marginRight: 5}}/>}
                    label={t("accessibility.searchUsersTextbox")}
                />
                {/* <DatePickerInput
                    ref={dateCreatedRef}
                    displayFormat='DD-MM-YYYY'
                    style={{paddingLeft: "10px", width: "160px"}}
                    placeholder={t("table.dateCreatedHeader")}
                    onChange={value => {
                        if (!isNaN(value)) {
                            setDateCreatedFilter(value.toISOString().split('T')[0]);
                        } else {
                            setDateCreatedFilter("");
                        }
                    }}
                    value={dateCreatedFilter}
                    aria-label={t("accessibility.selectDateCreated")}
                    onFocus={() => dateCreatedRef.current?.show()}
                    onBlur={() => dateCreatedRef.current?.hide()}
                />
                <DatePickerInput
                    ref={lastAccessedRef}
                    displayFormat='DD-MM-YYYY'
                    style={{paddingLeft: "10px", width: "160px"}}
                    placeholder={t("table.lastAccessedHeader")}
                    onChange={value => {
                        if (!isNaN(value)) {
                            setLastAccessedFilter(value.toISOString().split('T')[0]);
                        } else {
                            setLastAccessedFilter("");
                        }
                    }}
                    value={lastAccessedFilter}
                    aria-label={t("accessibility.selectLastAccessed")}
                    onFocus={() => lastAccessedRef.current?.show()}
                    onBlur={() => lastAccessedRef.current?.hide()}
                />
                <YuJaDropdown
                    ariaLabel={translateDisplayValue(roleFilter) + t("accessibility.roleDropdownSuffix")}
                    data={roles}
                    getOptionLabel={translateDisplayValue}
                    getOptionValue={item => item}
                    onChange={option => setRoleFilter(option)}
                    value={roleFilter}
                    containerStyle={{paddingLeft: 10, width: 130}}
                    style={{padding: "8px 15px"}}
                />
                <YuJaDropdown
                    ariaLabel={translateDisplayValue(linkageTypeFilter) + t("accessibility.linkageTypeDropdownSuffix")}
                    data={linkageTypes}
                    getOptionLabel={translateDisplayValue}
                    getOptionValue={item => item}
                    onChange={option => setLinkageTypeFilter(option)}
                    value={linkageTypeFilter}
                    containerStyle={{paddingLeft: 10, width: 110}}
                    style={{padding: "8px 15px"}}
                /> */}
                <YuJaButton style={{marginLeft: 10}} onClick={clickSearch}>{t("common.search")}</YuJaButton>
                <YuJaButton style={{marginLeft: 10}} onClick={handleCreate}>
                    <PlusIcon style={{width: 15, height: 15, marginRight: 5}}/>{t("user.createUser")}
                </YuJaButton>
                {showDeleteButton &&
                    <div className={styles.deleteSelectedBtn}>
                        <YuJaButton type="delete" onClick={handleDelete} style={{minWidth: 70, flexShrink: 0}}>{t("common.delete")}</YuJaButton>
                    </div>
                }
            </Form>
        </div>
    );
}
